<div>
    <button class="dialog-close-btn" aria-label="close dialog" mat-dialog-close>
        <img src="/icons/close_image-grey.svg" alt="" class="close" width="25" />
    </button>
</div>
<mat-dialog-content>
    <div class=" mt-3">
        <div class="checkout_merge_popup">
            <div class="cart_merge_popup">
                <span>{{'common.cart_page_merge_message'|cxTranslate}}</span>
            </div>
            <div class="d-flex align-items-center col-12 mt-4 p-0 cart_merge_buttons">
                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 d-flex p-0 justify-content-center cart-merge-left-btn">
                    <button class="btn button button-launch" (click)="redirectToCheckoutPage()" mat-dialog-close>
                        {{'common.text_quote_yes_button_label'|cxTranslate}}
                        <img src="/icons/link-dark-grey.svg" class="icon-right" alt="">
                    </button>
                        
                </div>
                <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 d-flex justify-content-center cart-merge-right-btn">
                    <button class="btn btn-checkout" mat-dialog-close>
                        {{'common.text_warranty_submit_labourrequested_no'|cxTranslate}}</button>
                </div>
            </div>
        </div>

    </div>
</mat-dialog-content>